import React from 'react';
import { Breadcrumb } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Container } from 'react-bootstrap';
import Footer from '../../Footer';
import './Formation.css';
import { useTranslation } from 'react-i18next';

const Formation = () => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1024px)' });
  const { t } = useTranslation();

  return (
    <HelmetProvider>
      <div className='container_For'>
      <Helmet>
          <meta charSet="utf-8" />
          <title>{t('Professional Inspectors - Formations Professionnelles')}</title>
          <meta
            name="description"
            content={t("Découvrez nos formations professionnelles. Formations interentreprises, intra-entreprise, cycles spécialisés, cycle de formation sécurité incluant habilitation des conducteurs d'engins, habilitation électrique, lutte contre l'incendie, premiers secours, sauveteurs secouristes au travail, cycles de formations aux systèmes de management QSE (ISO 14001, ISO 9001, ISO 45001, ISO 19011).")}
          />
          <meta
            name="keywords"
            content={t("Formations professionnelles, Formations interentreprises, Formations intra-entreprise, Cycles de formations spécialisés, Habilitation des conducteurs d'engins, Habilitation électrique, Lutte contre l'incendie, Premiers secours, Sauveteurs secouristes au travail, Cycles de formations aux systèmes de management QSE, ISO 14001, ISO 9001, ISO 45001, ISO 19011, Professional Inspectors")}
          />
        </Helmet>

        <Container fluid={isDesktopOrLaptop ? false : true}>
          <Breadcrumb separator=">">
            <Breadcrumb.Item href="/">{t('Accueil')}</Breadcrumb.Item>
            <Breadcrumb.Item >{t('Formation')}</Breadcrumb.Item>
          </Breadcrumb>
        </Container>

        <div className="tabs-to-dropdown">
          <div className={`d-flex ${isDesktopOrLaptop ? 'justify-content-between align-items-start' : 'flex-column align-items-center'}`}>
            <div className="nav-wrapper">
              <ul className={`nav nav-pills ${isDesktopOrLaptop ? 'd-md-flex' : 'd-flex d-md-none'}`} id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <a className="nav-link active" id="pills-company-tab" data-toggle="pill" href="#pills-company" role="tab" aria-controls="pills-company" aria-selected="true">{t('Nos activités de formation')}</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="pills-product-tab" data-toggle="pill" href="#pills-product" role="tab" aria-controls="pills-product" aria-selected="false">{t('Cycle de Formation sécurité')}</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="pills-news-tab" data-toggle="pill" href="#pills-news" role="tab" aria-controls="pills-news" aria-selected="false">{t('Cycle de Formation des équipes de secours')}</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="pills-sm-tab" data-toggle="pill" href="#pills-sm" role="tab" aria-controls="pills-sm" aria-selected="false">{t('Cycle de Formations aux systèmes de management QSE')}</a>
                </li>
              </ul>
            </div>

            <div className="tab-content" id="pills-tabContent">
    <div className="tab-pane fade show active" id="pills-company" role="tabpanel" aria-labelledby="pills-company-tab">
      <div className="container-fluid">
        <h2 className="mb-3 font-weight-bold">{t('Nos activités de formation')}</h2>
        <div className="row about">
                    <div className="col-sm-12">
                        <div className="pic us">
                            <img src="images/femme-affaires.jpg" className="img-fluid intro_image_f" alt="formation"/></div>
                    </div>
                    </div>
        
                    <h2>{t('Formations Interentreprises')}</h2>
    <ul>
        <li>{t('- Vos employés bénéficient des partages d\'expériences par l\'échange riche et varié avec les autres participants.')}</li>
        <li>{t('- Des évaluations post formation seront réalisées pour mesurer l\'acquisition des savoirs et savoir-faire.')}</li>
        <li>{t('- Nos programmes de formation sont conçus et mis à jour par des spécialistes hautement qualifiés qui allient pédagogie et pragmatisme.')}</li>
    </ul>

    <h2>{t('Formations Intra Entreprise')}</h2>
    <ul>
        <li>{t('- Pour répondre aux besoins et attentes de vos collaborateurs, PI conçoit, propose, réalise et assure le suivi de formations spécifiques à votre activité et personnalisées.')}</li>
        <li>{t('- Les dates de formation sont décidées d’un commun accord.')}</li>
        <li>{t('- Nous évoquons des situations distinguées, des exercices et simulations sur terrain pour une préparation opérationnelle de vos équipes.')}</li>
    </ul>

    <h2>{t('Cycles de Formation Spécialisés')}</h2>
    <ul>
        <li>{t('- Vous permettent de répondre à des besoins et connaissances spécifiques.')}</li>
        <li>{t('- Affinent et consolident vos savoirs et savoir-faire.')}</li>
        <li>{t('- Vous offrent des outils opérationnels.')}</li>
    </ul>

      </div>
    </div>
    <div className="tab-pane fade" id="pills-product" role="tabpanel" aria-labelledby="pills-product-tab">
      <div className="container-fluid">
        <h2 className="mb-3 font-weight-bold">{t('Cycle de Formation sécurité')}</h2>
        <div className="row about">
                    <div className="col-sm-12">
                        <div className="pic us">
                            <img src="images/chariot-elevateur.jpg" className="img-fluid intro_image_f" alt="securite"/></div>
                    </div>
                    </div>
                    <h2>1. {t('Habilitation des conducteurs d’engins : Chariots Élévateurs, Pont Roulant, Nacelle, Grues')}</h2>
    <h3>{t('Objectifs de formation')} :</h3>
    <ul><li>{t('Apprendre les règles et les consignes de sécurité nécessaires pour une conduite en sécurité de l’engin de manutention. Apprendre les gestes utiles pour une conservation meilleure de l’équipement et des personnes.')}</li></ul>
    <h3>{t('Personnes concernées')} :</h3>
    <p>{t('Toute personne expérimentée ou non, appelée dans le cadre de ses fonctions, à conduire de manière exceptionnelle ou récurrente un engin de manutention.')}</p>

    <h2>2.{t('Habilitation électrique')}:</h2>
    <h3>{t('Objectifs de formation')}:</h3>
    <ul><li>{t('Acquérir une compétence pour l’exécution des opérations d’ordre électrique ou non électrique en toute sécurité. Connaitre les mesures d’urgence à prendre en cas d’accident ou l’incident d’origine électrique.')}</li></ul>
    <h3>{t('Personnes concernées')}:</h3>
    <p>{t('Personnels électriciens ou électromécanicien, Personnels non électriciens exécutant des travaux à proximité des installations électriques ou dans des zones présentant des risques électriques.')}</p>

      </div>
    </div>
    <div className="tab-pane fade" id="pills-news" role="tabpanel" aria-labelledby="pills-news-tab">
      <div className="container-fluid">
        <h2 className="mb-3 font-weight-bold">{t('Cycle de Formation des équipes de secours')}</h2>
        <div className="row about">
                    <div className="col-sm-12">
                        <div className="pic us">
                            <img src="images/ins.jpg" className="img-fluid intro_image_f " alt="secours"/></div>
                    </div>
                    </div>
                    <h2>1. {t('Lutte Contre l\'incendie')}</h2>
    <h3>{t('Objectifs de la formation')} :</h3>
    <ul>
        <li>- {t('Acquérir les principes fondamentaux de lutte contre le feu.')}</li>
        <li>- {t('Apprendre les bons réflexes à adopter à la découverte d’un incendie.')}</li>
        <li>- {t('Utiliser efficacement les moyens disponibles de protection dans l’entreprise pour faire face à un début d’incendie.')}</li>
        <li>- {t('Appliquer les consignes de sécurité incendie de l’établissement pour une évacuation rapide et sûre.')}</li>
    </ul>
    <h3>{t('Personnes concernées')} :</h3>
    <p>{t('Tout le personnel (administratifs, techniques…)')}</p>

    <h2>2. {t('Premiers Secours')}</h2>
    <h3>{t('Objectifs de la formation')} :</h3>
    <ul>
        <li>- {t('Maitriser la conduite à tenir et les gestes de premiers secours (mettre en sécurité la personne accidentée, réagir face à un saignement ou un étouffement…).')}</li>
        <li>- {t('Savoir qui et comment alerter dans l’entreprise ou à l’extérieur de l’entreprise.')}</li>
        <li>- {t('Repérer les situations dangereuses dans son entreprise et savoir à qui et comment relayer ces informations dans l’entreprise.')}</li>
    </ul>
    <h3>{t('Personnes concernées')} :</h3>
    <p>{t('Tout le personnel (administratifs, techniques…)')}</p>

    <h2>3. {t('Sauveteurs Secouristes au Travail')}</h2>
    <h3>{t('Objectifs de la formation')} :</h3>
    <ul>
        <li>- {t('Maitriser la conduite à tenir et les gestes de premiers secours (mettre en sécurité la personne accidentée, réagir face à un saignement ou un étouffement…).')}</li>
        <li>- {t('Savoir qui et comment alerter dans l’entreprise ou à l’extérieur de l’entreprise.')}</li>
        <li>- {t('Repérer les situations dangereuses dans son entreprise et savoir à qui et comment relayer ces informations dans l’entreprise.')}</li>
    </ul>
    <h3>{t('Personnes concernées')} :</h3>
    <p>{t('Tout le personnel (administratifs, techniques…)')}</p>
      </div>
    </div>
   
    
    
    <div className="tab-pane fade" id="pills-sm" role="tabpanel" aria-labelledby="pills-sm-tab">
      <div className="container-fluid tab-pane-container">
        <h2 className="mb-3 font-weight-bold">{t('Cycle de Formations aux systèmes de management QSE')}</h2>
        <div className="row about">
                    <div className="col-sm-12">
                        <div className="pics us">
                            <img src="images/stand.jpg" className="img-fluid intro_image_f " alt="QSE"/></div>
                    </div>
                    </div>

    <ul>
        <li>ISO 14001:2015</li>
        <li>ISO 9001:2015</li>
        <li>ISO 45001:2018</li>
        <li>ISO 19011:2018</li>
    </ul>
      </div>
    </div>
    
    
    
  </div>
</div>
</div>

<Footer />
      </div>
    </HelmetProvider>
  );
};

export default Formation;